import { Component, Element, Host, Prop, h } from '@stencil/core';

const ArrowIcon = ():SVGElement => (
  <svg viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 1l5.07130435 5.29043478L11 1" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round"/>
  </svg>
);

@Component({
  tag: 'zpr-navbar-dropdown',
  styleUrl: 'navbar-dropdown.scss',
})

export class ZprNavbar {
  @Element() el: HTMLElement;
  @Prop({reflect: true}) link: '#';
  @Prop({reflect: true}) buttonText: 'Dropdown';
  @Prop({reflect: true}) isOpenWithHover? = false;

  componentDidLoad() {
    const dropdownEl = this.el.querySelector('zpr-dropdown')
    const toggleEl = dropdownEl.querySelector('[slot="toggle"]');
    const bodyEl = dropdownEl.querySelector('[slot="body"]');

    if (this.isOpenWithHover) {
      toggleEl?.addEventListener('mouseover', (ev: Event) => {
        ev.preventDefault()
        this.resetOpenedDropdown()
        dropdownEl.open()
      })
      bodyEl?.addEventListener('mouseleave', (ev: Event) => {
        ev.preventDefault()
        dropdownEl.close()
      })
    }
  }

  resetOpenedDropdown() {
    const navbarDropdownElements =  document.querySelectorAll('.desktop-navbar zpr-dropdown');
    navbarDropdownElements.forEach((dropdown: HTMLZprDropdownElement) => {
      dropdown.close();
    })
  }

  render() {
    return (
      <Host>
        <zpr-dropdown is-open-with-hover={this.isOpenWithHover}>
          <a href={this.link} class="btn btn-ghost btn-medium" slot="toggle">
            { this.buttonText }
            <span class="arrow-icon"><ArrowIcon /></span>
            <span class="indicator-icon"></span>
          </a>
          <slot name="body"></slot>
        </zpr-dropdown>
      </Host>
    )
  }
}